import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/providers/react-query.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/styles/index.css");
